import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SharedModule } from '../../shared';
import { MessageModule } from '../../shared/message/message.module';
import { HomeMaterialModule } from '../home-material/home-material.module';

import { AdminManageClaimsComponent } from './admin-manage-claims.component';
import { AdminSalesClaimsComponent } from './components/admin-sales-claims/admin-sales-claims.component';
import { AdminClaimedDealsComponent } from './components/admin-claimed-deals/admin-claimed-deals.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatTableModule,
    MatProgressSpinnerModule,
    HomeMaterialModule,
    MessageModule,
    SharedModule,
  ],
  declarations: [
    AdminManageClaimsComponent,
    AdminSalesClaimsComponent,
    AdminClaimedDealsComponent,
  ],
  exports: [
    AdminManageClaimsComponent,
  ],
  entryComponents: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class AdminManageClaimsModule { }
